<template>
  <div :class="$style.container">
    <section :class="$style.main">
      <slot/>
    </section>
  </div>
</template>

<script>
export default {
  name: 'LayoutCreate',
};
</script>

<style lang="scss" module>
.container {
  position: relative;
  margin: 24px;
  padding: 24px;
  background: #fff;
}

.main {
  position: relative;
}
</style>
